var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"actTop_Banner",style:(_vm.bgstyle)},[_c('div',{staticClass:"actTop_BtnWrap"},_vm._l((_vm.btnInfo),function(actBtn,index){return _c('a',{key:index,staticClass:"actTop_Btn",attrs:{"href":actBtn.btnLink,"target":"_blank"},domProps:{"textContent":_vm._s(actBtn.btnName)}})}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46dfcfba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/actModules/pc/templates/banner/bannerTwo.vue
// module id = null
// module chunks = 